"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.packageInfo = void 0;
// Copyright 2017-2022 @polkadot/wasm-util authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Do not edit, auto-generated by @polkadot/dev

const packageInfo = {
  name: '@polkadot/wasm-util',
  path: typeof __dirname === 'string' ? __dirname : 'auto',
  type: 'cjs',
  version: '6.4.1'
};
exports.packageInfo = packageInfo;